import React from "react";
import ErrorDisplay from "@directv-digital/dds.ui.error-display";
import DtvBox from "@directv-digital/dds.ui.dtv-box";
import DtvText from "@directv-digital/dds.ui.dtv-text";
import { PackageCarouselTopperProps } from "../package-carousel.props";
import CtaSection from "./CtaSection";

const styles = {
  topperContainerStyles: {
    m: {
      xs: "0 20px 8px 20px",
      sm: "0 32px 8px 32px",
      md: "0 140px 8px 140px"
    },
    display: "flex",
    flexDirection: {
      xs: "column",
      sm: "row"
    },
    justifyContent: { md: "space-between" },
    gap: {
      xs: "12px",
      sm: "0px",
      md: "48px"
    }
  },
  textContainerStyles: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "16px"
  },
  pricingContainerStyles: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start"
  },
  ctaContainerStyles: {
    flexDirection: "column",
    height: "auto",
    justifyContent: "end",
    alignItems: "end",
    gap: "14px",
    ml: {
      xs: "0",
      sm: "48px"
    }
  }
};

const PackageCarouselTopper = (props: PackageCarouselTopperProps) => {
  const { title, subHeading, bodyText, priceText, cta, secondaryCta, config } =
    props;
  try {
    return (
      <DtvBox
        data-testid="package-carousel-topper"
        id={`package-carousel-topper-container`}
        sx={{
          ...styles.topperContainerStyles
        }}
      >
        {/* package-carousel-topper-text-container */}
        <DtvBox sx={{ ...styles.textContainerStyles }}>
          {/* package-carousel-topper-header-section */}
          <DtvBox>
            {title?.content && <DtvText {...title} />}
            {subHeading?.content && <DtvText {...subHeading} />}
            {bodyText?.content && <DtvText {...bodyText} />}
          </DtvBox>
          {/* "package-carousel-topper-pricing-section */}
          {priceText?.content && (
            <DtvBox sx={{ ...styles.pricingContainerStyles }}>
              {priceText?.bodyText?.content && (
                <DtvText {...priceText?.bodyText} />
              )}
              <DtvBox>
                {priceText?.content && (
                  <DtvText
                    content={priceText?.content}
                    variant={priceText?.variant}
                    sx={{
                      color: priceText?.color,
                      display: "inline",
                      fontWeight: "bold"
                    }}
                  />
                )}
                {priceText?.spanText?.content && (
                  <DtvText
                    {...priceText?.spanText}
                    display="inline"
                    fontWeight="bold"
                  />
                )}
                {priceText?.legal?.content && (
                  <DtvText {...priceText?.legal} display="inline" />
                )}
              </DtvBox>
            </DtvBox>
          )}
        </DtvBox>
        {/* package-carousel-topper-cta-container */}
        {(cta || secondaryCta) && (
          <DtvBox
            sx={{
              ...styles.ctaContainerStyles,
              display: {
                xs: config?.isCtaPositionBottom ? "none" : "flex",
                sm: "flex"
              }
            }}
          >
            <CtaSection cta={cta} secondaryCta={secondaryCta} />
          </DtvBox>
        )}
      </DtvBox>
    );
  } catch (error) {
    return <ErrorDisplay component="Dtv Card" error={error} />;
  }
};

export default React.memo(PackageCarouselTopper);
